'use strict';
import { get, isNil, merge, reduce, set, forEach } from 'lodash';
import moment from 'moment';
import React, { PropTypes } from 'react';
import { validateFormField } from '../../../../../../modelValidator';
import { mapFormFields, fieldsHasErrors } from '../../../../../../lib/form';
import { push } from 'react-router-redux';

import { convertEmployeeToMenuItems } from '../../../../../../redux/helpers/staticData';
import * as companyApi from '../../../../../../redux/actionCreators/async/companies';
import * as companyStore from '../../../../../../redux/actionCreators/sync/companies';
import * as ui from '../../../../../../redux/actionCreators/sync/ui';
import TextField from '../../../../../../common/components/c_TextField';
import MaskedTextField from '../../../../../../common/components/c_MaskedTextField';
import DropDownMenu from '../../../../../../common/components/c_DropDownMenu';
import DateInput from '../../../../../../common/components/DateInput';
import Button from '../../../../../../common/components/Button';
import ModalX from '../../../../../../common/svgs/ModalX';
import Modal from '../../../../../../common/components/r_Modal';

const formFields = {
  company: {
    required : ['name', 'address', 'city', 'state', 'zip'],
    optional : ['accountTypeId', 'relationshipManagerId', 'phoneNumber', 'timezone', 'website', 'address2', 'dateCreated', 'dateModified']
  }
};

function EditCompanyDetailsForm(props) {
  const {
    updateField,
    saveCompany,
    onClose,
    onDelete,
    company,
    relationshipManagers,
    timezoneList,
    stateList,
    isDirty,
    hasErrors,
    website,
  } = props || {};

  function handleDelete() {
    return (event) => {
      if(onDelete) {
        return onDelete(event);
      }
    };
  }

  function handleChange(model, prop) {
    return (event, value) => updateField(event, model, prop, value);
  }

  function handleSave(event) {
    (saveCompany) && saveCompany(event);
  }

  return (
    <div className='topmodal'>
      <ModalX onClick={onClose}  />
      <div className='topmodal-container'>
        <div className='grid grid-topmodal'>
          <div className='row'>
            <div className='col grow-2'>
                <TextField
                defaultValue={get(company, 'company.name.defaultValue')}
                floatingLabelText={"Company Name"}
                errorText={get(company, 'company.name.errors[0]')}
                onChange={handleChange('company', 'name')}
                isDirty={isDirty || hasErrors}
              />
            </div>
            <div className='col grow-2'>
              <div className='row'>
                <div className='col'>
                   <TextField
                    defaultValue={get(company, 'company.address.defaultValue')}
                    floatingLabelText={"Address Line 1"}
                    errorText={get(company, 'company.address.errors[0]')}
                    onChange={handleChange('company', 'address')}
                    isDirty={isDirty || hasErrors}
                />

                </div>
                <div className='col'>
                  <TextField
                    defaultValue={get(company, 'company.address2.defaultValue')}
                    floatingLabelText={"Address Line 2"}
                    errorText={get(company, 'company.address2.errors[0]')}
                    onChange={handleChange('company', 'address2')}
                    isDirty={isDirty || hasErrors}
                  />
                </div>
              </div>

            </div>
            <div className='col'>
              <DateInput
                defaultValue={moment(get(company, 'company.dateCreated.defaultValue')).format('L')}
                floatingLabelText={"Entered"}
                disabled
                isDirty={isDirty || hasErrors}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col grow-2'>
               <DropDownMenu
                  defaultValue={get(company, 'company.relationshipManagerId.defaultValue')}
                  floatingLabelText={"Relationship Manager"}
                  errorText={get(company, 'company.relationshipManagerId.errors[0]')}
                  onChange={handleChange('company', 'relationshipManagerId')}
                  menuItems={convertEmployeeToMenuItems(relationshipManagers)}
                  isDirty={isDirty || hasErrors}
                />
            </div>
            <div className='col grow-2'>
              <div className='row'>
                <div className='col'>
                  <TextField
                    data-id={"City"}
                    defaultValue={get(company, 'company.city.defaultValue')}
                    floatingLabelText={"City"}
                    errorText={get(company, 'company.city.errors[0]')}
                    onChange={handleChange('company', 'city')}
                    isDirty={isDirty || hasErrors}
                  />

                </div>
                <div className='col'>
                  <DropDownMenu
                    defaultValue={get(company, 'company.state.defaultValue')}
                    floatingLabelText={"State"}
                    errorText={get(company, 'company.state.errors[0]')}
                    onChange={handleChange('company', 'state')}
                    menuItems={stateList}
                    isDirty={isDirty || hasErrors}
                  />
                </div>
                <div className='col'>
                  <TextField
                    defaultValue={get(company, 'company.zip.defaultValue')}
                    floatingLabelText={"Zip Code"}
                    errorText={get(company, 'company.zip.errors[0]')}
                    onChange={handleChange('company', 'zip')}
                    isDirty={isDirty || hasErrors}
                    maxLength='5'
                  />
                </div>
              </div>
            </div>
            <div className='col'>
              <DateInput
                    defaultValue={moment(get(company, 'company.dateModified.defaultValue')).format('L')}
                    floatingLabelText={"Last Updated"}
                    disabled
                    isDirty={isDirty || hasErrors}
                />
            </div>
          </div>
          <div className='row'>
            <div className='col grow-2'>
              <TextField
                defaultValue={get(company, 'company.website.defaultValue', '') || website}
                floatingLabelText={'Company Website'}
                errorText={get(company, 'company.website.errors[0]')}
                onChange={handleChange('company', 'website')}
                isDirty={isDirty || hasErrors}
              />
            </div>
            <div className='col grow-2'>
              <div className='row'>
                <div className='col'>
                  <MaskedTextField
                    mask='(999) 999-9999'
                    hideMaskChar={true}
                    value={get(company, 'company.phoneNumber.defaultValue')}
                    floatingLabelText={"Main Number"}
                    errorText={get(company, 'company.phoneNumber.errors[0]')}
                    onChange={handleChange('company', 'phoneNumber')}
                    isDirty={isDirty || hasErrors}
                  />
                </div>
                <div className='col'>
                  <DropDownMenu
                      defaultValue={get(company, 'company.timezone.defaultValue', '')}
                      floatingLabelText={"Time Zone"}
                      errorText={get(company, 'company.timezone.errors[0]')}
                      onChange={handleChange('company', 'timezone')}
                      menuItems={timezoneList}
                      isDirty={isDirty || hasErrors}
                    />
              </div>
              </div>
            </div>
            <div className='col'></div>
          </div>
        </div>
        {hasErrors && <div className='error-message'>Please fill out missing fields.</div>}
            <div className='actions'>
              {
                onDelete &&
                <Button
                  className={'button-delete'}
                  data-id={'Delete'}
                  label={'DELETE'}
                  onClick={handleDelete()}
                />
              }
              <Button
                className={'button-cancel button-secondary'}
                data-id={'Cancel'}
                label={'CANCEL'}
                onClick={onClose}
              />
              <Button
                className={'button-save'}
                data-id={'Save'}
                label={'SAVE'}
                disabled={!isDirty}
                onClick={handleSave}
              />
          </div>

      </div>
    </div>
  );
}

export default class EditCompanyDetails extends React.Component {
  static propTypes = {
    company : PropTypes.object.isRequired,
    relationshipManagers : PropTypes.array.isRequired,
    timezoneList : PropTypes.array.isRequired,
    stateList : PropTypes.array.isRequired,
    dispatch : PropTypes.func.isRequired,
    onClose : PropTypes.func.isRequired,
    website : PropTypes.string,
    currentUser : PropTypes.object
  }

  constructor(props, context) {
    super(props, context);

    const company = props.company;

    const form = {
      company : mapFormFields(company, formFields.company.required, formFields.company.optional)
    };

    this.state = form;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.company) {
      const {
        company
      } = nextProps.company;
      const form = {
        company : mapFormFields(company, formFields.company.required, formFields.company.optional)
      };

      this.setState(form);
    }
  }

  validateForm(form, fields) {
    forEach(form, (prop, key) => {
      if (fields.required.includes(key)) {
        set(form, `${key}.errors`,  validateFormField(key, form));
      }
    });
  }

  saveCompany = () => {

    const company = merge({}, this.state.company);

    this.validateForm(company, formFields.company);

    const hasErrors = fieldsHasErrors(company);

    if (hasErrors) {
      return this.setState({company, hasErrors});
    }

    const newCompany = reduce(this.state, (updateObj, model, key) =>
      set(updateObj, key,
          reduce(model,
            (obj, prop, name) => !isNil(get(prop, 'value')) ? set(obj, name, get(prop, 'value')) : obj,
            { id: this.props.company.id, companyStatus: this.props.company.companyStatus }
          )
    ), {});

    this.props.dispatch(companyApi.updateCompany(newCompany.company, (err, data) => {
      if (err) {
        return console.error(err);
      }
      data.company.dateModified = new Date();
      this.props.dispatch(companyStore.updateCompany(data));
      this.props.dispatch(ui.showSnackBar());
      this.props.onClose();
    }));
  }

  onDelete = () => {
    this.setState({showConfirmDelete: true});
  }

  updateField = (event, model, prop, value) => {
    const currentState = merge({}, this.state);
    const newValue = value || event.target.value;
    const reverted = get(currentState, `${model}.${prop}.defaultValue`) === newValue;
    const newState = set(currentState, `${model}.${prop}.value`, (reverted) ? undefined : newValue);
    set(newState, `${model}.${prop}.errors`, (reverted) ? null : validateFormField(prop, newState[model]));
    this.setState(newState);
  }

  performDelete = () => {
    const { dispatch, company, onClose } = this.props;
    if (company && company.id) {
      dispatch(

        companyApi.deleteCompany(company.id, (err) => {
          if (err) {
            return console.error(err);
          }

          onClose();
          dispatch(ui.showSnackBar(`Company ${company.name} has been deleted.`));
          dispatch(push('/admin/companies/'));
        })

      );
    }
  }

  cancelDelete = () => {
    this.setState({showConfirmDelete: false});
  }

  renderConfirmDelete(state) {

    const {showConfirmDelete} = state;

    if (showConfirmDelete) {
      return(
        <Modal>
          <div className='route-transition-blocker-transition-block-form'>
            <ModalX onClick={this.cancelDelete}/>
            <div>
              <div className='prompt-text'>
                Are you really sure you want to delete this company? This action cannot be reversed.
              </div>
              <div className='actions'>
                <Button
                  className={'button-cancel button-secondary'}
                  label={'DO NOT DELETE'}
                  onClick={this.cancelDelete}
                />
                <Button
                  className={'button-delete'}
                  label={'DELETE'}
                  onClick={this.performDelete}
                />
              </div>
            </div>
          </div>
          <div className='rectangle-behind-modal-form absolute-center'/>
        </Modal>
      );
    }
  }

  render() {

    const saveEnabled = reduce(this.state, (enabled, model) =>
      enabled || reduce(model, (enable, prop) =>
        enable || !isNil(prop.value) && (!prop.errors || !prop.errors.length), false)
    , false);

    const allowedDelete = get(this.props, 'currentUser.roles', []).includes('Admin');

    return (
      <div className='company-card'>
        {
          this.renderConfirmDelete(this.state, this.props)
        }
        <EditCompanyDetailsForm
          company={this.state}
          website={this.props.website}
          relationshipManagers={this.props.relationshipManagers}
          timezoneList={this.props.timezoneList}
          stateList={this.props.stateList}
          isDirty={saveEnabled}
          updateField={this.updateField}
          saveCompany={this.saveCompany}
          onClose={this.props.onClose}
          onDelete={allowedDelete && this.onDelete}
          hasErrors={this.state.hasErrors}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Company/Worksheet/Header/EditDetails/index.js